import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';

export const styles = {
  tabs: {
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      display: 'none',
    },
  },
};
